<template>
  <Loader id="goldfish-manual" :value="promise">
    <Navigation :value="boat" />
    <Hero :title="boat.tittel" :image="boat.baatBilde" />
    <div class="uk-section uk-padding">
      <div class="uk-container uk-container-large">
        <TOC :chapters="boat.Kapitler" style="margin-top: 4em" />
        <hr />
        <div
          v-for="item in boat.Kapitler"
          :key="item.id"
          style="padding-top: 5rem"
        >
          <component
            :is="Blocks['ComponentElementTittel']"
            :value="{
              Tittel: item.Tittel,
              Tittel_eng: item.Tittel_eng,
            }"
            :variables="boat.Variabler"
            :level="2"
          />
          <component
            :is="Blocks[block.__typename]"
            :value="block"
            :chapter="item.Tittel"
            :variables="boat.Variabler"
            v-for="block in item.kapittel.blocks"
            :key="block.id"
          />
          <hr />
        </div>
      </div>
    </div>
  </Loader>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
import Hero from "@/components/Hero.vue";
import TOC from "@/components/TOC.vue";
import Blocks from "@/components/Blocks";
import { LoaderComponent as Loader } from "vue-elder-loader";

import { Slugify as slugify, ScrollTo as scrollTo } from "@/utils";
import BoatQuery from "@/graphql/queries/Boat.gql";
import Graphql from "@/graphql";

export default {
  data() {
    return {
      boat: {},
      promise: null,
      Blocks,
    };
  },
  methods: {
    slugify,
    scrollTo,
    fetch() {
      let id = this.$root.$el.getAttribute("boat-id");
      this.promise = Graphql.request(BoatQuery, { id }).then(
        (res) => (this.boat = res.baat)
      );
    },
  },
  components: {
    Navigation,
    Hero,
    TOC,
    Loader,
  },
  created() {
    let unwatch = this.$watch(
      "boat",
      () => {
        if (!this.boat || !this.boat.__typename) return;
        if (unwatch) unwatch();
        if (this.$route.hash) this.scrollTo(this.$route.hash);
      },
      { immediate: true, deep: true }
    );

    this.fetch();
  },
};
</script>

<style lang="scss">
html {
  scroll-behavior: smooth;
}

#goldfish-manual {
  a {
    text-decoration: none;
  }

  body {
    font-family: "proxima-nova";
    font-weight: 400;
  }

  p {
    font-family: "proxima-nova";
    font-weight: 400;
  }

  h1 {
    font-size: 3.25rem;
    font-family: "acumin-pro-wide";
    font-weight: 500;
  }

  h2 {
    font-size: 2rem;
    font-family: "acumin-pro-wide";
    font-weight: 500;
    margin-bottom: 40px;
  }

  h3 {
    font-size: 1.2rem;
    margin-top: 0rem;
    font-family: "acumin-pro-wide";
    font-weight: 500;
  }

  hr {
    margin-top: 6em;
  }

  .padding {
    padding-top: 4em;
  }
}
</style>
